import diagnoseGateway from "./diagnoseGateway";

// 입력 소스 공통 포트.
// 모든 입력(chat/control, direct/gateway)이 이 인터페이스 뒤에 숨는다 → 소비자(Reaction/Page)는 출처·전송을 모른다.
//  - provider: "chzzk" | "twitch" | "afreeca" | "virtupet"   (데이터 출처)
//  - kind:     "event-stream"                                (인터페이스 — 모든 입력이 StreamEvent)
//  - mode:     "direct" | "gateway"                          (전송 — 시간에 따라 바뀜)
export default class Source {
  constructor({ provider, kind, mode }) {
    this.provider = provider;
    this.kind = kind;
    this.mode = mode;
    // 소켓 상태(방송 여부와 무관): idle(open 전) | connecting(연결 시도) | ready(연결됨) | failed | closed
    this.status = "idle";
    this.statusDetail = null; // failed 원인 코드 (E_5XX/E_NETWORK/E_SOCKET/HTTP_xxx) — 상태바 병기용
    this._handlers = [];
    this._statusHandlers = [];
  }

  // payload 구독 (event-stream → StreamEvent; 단일 인터프리터가 type으로 해석)
  on(handler) {
    this._handlers.push(handler);
    return this;
  }

  // 연결 상태 구독 (sub별 상태 아이콘용). 구현체가 _setStatus로 갱신.
  onStatusChange(cb) {
    this._statusHandlers.push(cb);
    return this;
  }

  _setStatus(status, detail = null) {
    this.status = status;
    this.statusDetail = detail;
    this._statusHandlers.forEach((h) => {
      try {
        h(status, detail);
      } catch (error) {
        console.error(error);
      }
    });
  }

  // 게이트웨이 핸드셰이크 감시: connect_error 연속 N회 → failed + 원인 진단(1회) 병기.
  //  socket.io 재시도는 그대로 두므로 이후 연결되면 기존 connect 리스너가 ready로 복귀시킨다.
  _watchGatewayHandshake(socket, { threshold = 3 } = {}) {
    let errors = 0;
    let diagnosed = false;
    socket.on("connect", () => {
      errors = 0;
      diagnosed = false;
    });
    socket.on("connect_error", () => {
      errors += 1;
      if (errors < threshold || diagnosed) return;
      diagnosed = true;
      this._setStatus("failed");
      diagnoseGateway().then((detail) => {
        if (this.status === "failed") this._setStatus("failed", detail);
      });
    });
  }

  _emit(payload) {
    this._handlers.forEach((h) => {
      try {
        h(payload);
      } catch (error) {
        console.error(error);
      }
    });
  }

  // 구현체가 override
  open() {
    throw new Error("Source.open() not implemented");
  }
  close() {}
}
